// index.js - ONLY ADD THIS LINE
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react';

// 👇 ADD THIS LINE to get your Clerk key
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Check if key is valid and not a placeholder
const isValidKey = clerkPubKey && 
  (clerkPubKey.startsWith('pk_test_') || clerkPubKey.startsWith('pk_live_')) &&
  clerkPubKey !== 'pk_test_your_key_here' &&
  clerkPubKey.length > 30; // Real Clerk keys are longer

const container = document.getElementById('root');
if (!container) {
   throw new Error('Failed to find the root element');
}
const root = createRoot(container);

// Wrapper component for dev mode without Clerk
const DevWrapper = ({ children }) => {
   if (!isValidKey) {
      console.warn('⚠️ Clerk publishableKey is not configured or invalid.');
      console.warn('Running in development mode without authentication.');
      console.warn('To enable authentication:');
      console.warn('  1. Go to: https://dashboard.clerk.com/last-active?path=api-keys');
      console.warn('  2. Copy your Publishable Key');
      console.warn('  3. Edit .env and set: REACT_APP_CLERK_PUBLISHABLE_KEY=your_key_here');
      console.warn('  4. Restart the dev server');
      return <div>{children}</div>;
   }
   return <ClerkProvider
      publishableKey={clerkPubKey}
      appearance={{
         layout: {
            logoPlacement: 'inside',
            showOptionalFields: true,
         },
         elements: {
            card: {
               width: '100%',
               maxWidth: '95vw',
               padding: '48px',
               borderRadius: '16px',
               boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
            },
            headerTitle: {
               fontSize: '28px',
               fontWeight: '700',
               marginBottom: '8px',
            },
            headerSubtitle: {
               fontSize: '15px',
            },
            socialButtonsBlockButton: {
               height: '48px',
               fontSize: '15px',
               borderRadius: '8px',
            },
            formFieldInput: {
               height: '48px',
               fontSize: '15px',
               borderRadius: '8px',
               padding: '0 16px',
            },
            formFieldLabel: {
               fontSize: '14px',
               fontWeight: '600',
               marginBottom: '6px',
            },
            formButtonPrimary: {
               height: '50px',
               fontSize: '16px',
               fontWeight: '600',
               borderRadius: '8px',
               marginTop: '8px',
            },
            footerActionText: {
               fontSize: '14px',
            },
            footerActionLink: {
               fontSize: '14px',
               fontWeight: '600',
            },
            dividerText: {
               fontSize: '13px',
            },
            identityPreviewText: {
               fontSize: '15px',
            },
         }
      }}
   >{children}</ClerkProvider>;
};

root.render(
   <DevWrapper>
      <App />
   </DevWrapper>
);